<template>
    <div class="steps">
        <div class="steps-line"></div>
        <div class="steps-boxs">
            <div v-for="(item,index) in stepsData"
                :key="index"
                :class="{active:index === stepsIndex}"
                class="steps-item"><span>{{ item.value }}</span></div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    props: {

        stepsData: {

            type: Array,
            default (): any[] {

                return [];

            }
        },
        stepsIndex: {
            type: Number,
            default: 0
        }

    }
});
</script>

<style lang="less">
.steps{
    width: 100%;
    height: 0.3rem;
    position: relative;
    display: block;
    .steps-line{
        position: absolute;
        top: 50%;
        width: 100%;
        height: 0.01rem;
        background: @line;
    }
    .steps-boxs{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.3rem;
        display: flex;
        justify-content:center;
        align-items:center;
        .steps-item+.steps-item{
            margin-left: 0.7rem;
        }
        .steps-item{
            text-align: center;
            span{
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                border-radius: 100%;
                background-color: @line;
                line-height: 16px;
                text-align: center;
                font-size: 16px;
                font-weight: 500;
                z-index: 100;
                color: @white;
            }

        }
        .steps-item.active{
            span{
                background: @brand_light;
                color:@white;
            }
        }
    }
}

@media @mobile {
    .steps{
        width: 100%;
        height: 21px;
        position: relative;
        display: block;
        .steps-line{
            position: absolute;
            top: 50%;
            width: 100%;
            height: 1px;
        }
        .steps-boxs{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content:center;
            align-items:center;
            .steps-item+.steps-item{
                margin-left: 0.88rem;
            }
            .steps-item{
                text-align: center;
                span{
                    width: 21px;
                    height: 21px;
                    border-radius: 100%;
                    text-align: center;
                    font-size: 13px;
                    font-weight: 500;
                    z-index: 100;
                }

            }
        }
    }
}
</style>
